import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { Flex } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { ChatFooter } from "./ChatFooter";
import { ChatHeader } from "./ChatHeader";
import { ChatMessages } from "./ChatMessages";

export const ChatContent = ({ headerHeight, footerHeight }) => {
  const [chatHeaderHeight, setChatHeaderHeight] = useState(0);

  const chatHeaderRef = useCallback((node) => {
    if (node !== null) {
      setChatHeaderHeight(node.getBoundingClientRect().height);
    }
  }, []);

  const getChatMessagesHeight = () =>
    `calc(100vh - ${footerHeight + headerHeight + chatHeaderHeight}px)`;

  return (
    <Flex flexDirection="column" justifyContent="center" width="380px" flexGrow={0}>
      <ChatHeader chatHeaderRef={chatHeaderRef} />
      <ChatMessages chatMessagesHeight={getChatMessagesHeight()} />
      <ChatFooter footerHeight={footerHeight} />
    </Flex>
  );
};

ChatContent.propTypes = {
  headerHeight: PropTypes.number,
  footerHeight: PropTypes.number,
};

ChatContent.defaultProps = {
  headerHeight: 0,
  footerHeight: 0,
};

export default ChatContent;
